<script>
	export default {
		name: 'PointExecuter',
		methods: {
			getSumPointGivings(uid) {
				const self_ = this;

				let result_ = 0;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetPointGivings({ uid: uid })
					}).then(result => {
						if(!self_.isEmpty(result)) {
							result.forEach(data => {
								result_ += data.amount;
							})
						}
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			getSumPointRedemptions(uid) {
				const self_ = this;

				let result_ = 0;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetPointRedemptions({ uid: uid })
					}).then(result => {
						if(!self_.isEmpty(result)) {
							result.forEach(data => {
								result_ += data.amount;
							})
						}
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			getSumPointReturns(uid) {
				const self_ = this;

				let result_ = 0;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetPointReturns({ uid: uid })
					}).then(result => {
						if(!self_.isEmpty(result)) {
							result.forEach(data => {
								result_ += data.amount;
							})
						}
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			getSumPointCancellations(uid) {
				const self_ = this;

				let result_ = 0;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetPointCancellations({ uid: uid })
					}).then(result => {
						if(!self_.isEmpty(result)) {
							result.forEach(data => {
								result_ += data.amount;
							})
						}
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			getSumPointExpirations(uid) {
				const self_ = this;

				let result_ = 0;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetPointExpirations({ uid: uid })
					}).then(result => {
						if(!self_.isEmpty(result)) {
							result.forEach(data => {
								result_ += data.amount;
							})
						}
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			updatePointExpiration(uid) {
				const self_ = this;

/* debug */		self_.logDebug('Point Executer', 'Update point expiration started...', { uid: uid })

				const today_ = self_.formatDate(new Date(), 'YYYY-MM-DD')

				let sum_ = 0;
				let sumNotExpired_ = 0;

				const getSum_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getSumPointGivings(uid)
						}).then(result => {
							sum_ += result;
							return self_.getSumPointRedemptions(uid)
						}).then(result => {
							sum_ -= result;
							return self_.getSumPointReturns(uid)
						}).then(result => {
							sum_ += result;
							return self_.getSumPointCancellations(uid)
						}).then(result => {
							sum_ -= result;
							return self_.getSumPointExpirations(uid)
						}).then(result => {
							sum_ -= result;
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getSumNotExpired_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipCliGetPointGivings({ uid: uid })
						}).then(result => {
							if(!self_.isEmpty(result)) {
								result.forEach(data => {
									if(data['end_date'] >= today_) { sumNotExpired_ += data.amount }
								})
							}
							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const expire_ = () => {
/* debug */			self_.logDebug('Point Executer', 'Update Point Expiration: expire_ started...', { uid: uid })

					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							let promiseArray_ = []

							promiseArray_.push(getSum_())
							promiseArray_.push(getSumNotExpired_())

							return Promise.all(promiseArray_)
						}).then(() => {
							let amount_ = 0;
							if(sum_ > sumNotExpired_) { amount_ = sum_ - sumNotExpired_; }

							return self_.ipCliStorePointExpirations(uid, amount_, today_, '2999-12-31', null)
						}).then(() => {
/* debug */					self_.logDebug('Point Executer', 'Update Point Expiration: expire_ finished...', { uid: uid })

							resolve()
						}).catch(error => {
/* error */					self_.logError('Point Executer', 'Update Point Expiration: expire_ error...', { error: error })

							reject(error)
						})
					})
				}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.$_pointExec_sync(uid) // only for clients using old system
					}).then(() => {
						return self_.ipCliGetPointExpirations({ uid: uid, startDate: today_ })
					}).then(result => {
						if(!self_.isEmpty(result)) {
							return Promise.resolve()
						} else {
							return expire_()
						}
					}).then(() => {
/* debug */				self_.logDebug('Point Executer', 'Update point expiration finished...', { uid: uid })

						resolve()
					}).catch(error => {
/* error */				self_.logError('Point Executer', 'Update point expiration error...', { error: error })

						reject(error)
					})
				})
			},
			updateUserPointData(uid) {
				const self_ = this;

/* debug */		self_.logDebug('Point Executer', 'Update user point data started...', { uid: uid })

				let pointGivingAmount_ = 0;
				let pointRedemptionAmount_ = 0;
				let pointReturnAmount_ = 0;
				let pointCancellationAmount_ = 0;
				let pointExpirationAmount_ = 0;

				let promiseArray_ = []

				const getSumPointGivings_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getSumPointGivings(uid)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Update user point data: Get sum point givings...', { result: result })

							pointGivingAmount_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getSumPointRedemptions_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getSumPointRedemptions(uid)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Update user point data: Get sum point redemptions...', { result: result })

							pointRedemptionAmount_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getSumPointReturns_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getSumPointReturns(uid)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Update user point data: Get sum point returns...', { result: result })

							pointReturnAmount_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getSumPointCancellations_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getSumPointCancellations(uid)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Update user point data: Get sum point cancellations...', { result: result })

							pointCancellationAmount_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const getSumPointExpirations_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.getSumPointExpirations(uid)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Update user point data: Get sum point expirations...', { result: result })

							pointExpirationAmount_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						promiseArray_.push(getSumPointGivings_())
						promiseArray_.push(getSumPointRedemptions_())
						promiseArray_.push(getSumPointReturns_())
						promiseArray_.push(getSumPointCancellations_())
						promiseArray_.push(getSumPointExpirations_())

						return Promise.all(promiseArray_)
					}).then(() => {
						return self_.ipCliGetAppUserPointData({ uid: uid })
					}).then(result => {
						if(self_.isEmpty(result)) {
							return self_.ipCliStoreAppUserPointData(uid, pointGivingAmount_, pointRedemptionAmount_, pointReturnAmount_, pointCancellationAmount_, pointExpirationAmount_)
						} else {
							const body_ = {
								pointGivingAmount: pointGivingAmount_,
								pointRedemptionAmount: pointRedemptionAmount_,
								pointReturnAmount: pointReturnAmount_,
								pointCancellationAmount: pointCancellationAmount_,
								pointExpirationAmount: pointExpirationAmount_
							}

							return self_.ipCliUpdateAppUserPointData(uid, body_)
						}
					}).then(() => {
/* debug */				self_.logDebug('Point Executer', 'Update user point data finished...', { uid: uid })

						resolve()
					}).catch(error => {
/* error */				self_.logError('Point Executer', 'Update user point data error...', { error: error })

						reject(error)
					})
				})
			},
			$_pointExec_sync(uid) {
				const self_ = this;

/* debug */		self_.logDebug('Point Executer', 'Point sync started...', { uid: uid })

				const today_ = self_.formatDate(new Date(), 'YYYY-MM-DD')
				const oneYearFromToday_ = self_.formatDate(self_.addYear(new Date(), 1), 'YYYY-MM-DD')
				const yesterday_ = self_.formatDate(self_.addDay(new Date(), -1), 'YYYY-MM-DD')

				let oldSystemClientUserId_ = null;
				let ipcPointGiving_ = []
				let ipcItemOrders_ = []
				let pointGivings_ = []
				let pointRedemptions_ = []
				let pointReturns_ = []
				let pointCancellations_ = []
				let pointExpirations_ = []

				const ipcGetPointGiving_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipcGetPointGiving(oldSystemClientUserId_)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get ipc point giving...', { result: result })

							ipcPointGiving_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const ipcGetItemOrders_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipcGetItemOrders(oldSystemClientUserId_)
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get ipc item orders...', { result: result })

							ipcItemOrders_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const ipCliGetPointGivings_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipCliGetPointGivings({ uid: uid })
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get point givings...', { result: result })

							pointGivings_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const ipCliGetPointRedemptions_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipCliGetPointRedemptions({ uid: uid })
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get point redemptions...', { result: result })

							pointRedemptions_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const ipCliGetPointReturns_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipCliGetPointReturns({ uid: uid })
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get point returns...', { result: result })

							pointReturns_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const ipCliGetPointCancellations_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipCliGetPointCancellations({ uid: uid })
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get point cancellations...', { result: result })

							pointCancellations_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				const ipCliGetPointExpirations_ = () => {
					return new Promise((resolve, reject) => {
						Promise.resolve().then(() => {
							return self_.ipCliGetPointExpirations({ uid: uid })
						}).then(result => {
/* dev */					self_.logDev('Point Executer', 'Point sync: Get point expirations...', { result: result })

							pointExpirations_ = result;

							resolve()
						}).catch(error => {
							reject(error)
						})
					})
				}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppUsers({ uid: uid })
					}).then(result => {
						oldSystemClientUserId_ = result[0]['old_system_client_user_id']

						let promiseArray_ = []
						promiseArray_.push(ipcGetPointGiving_())
						promiseArray_.push(ipcGetItemOrders_())
						promiseArray_.push(ipCliGetPointGivings_())
						promiseArray_.push(ipCliGetPointRedemptions_())
						promiseArray_.push(ipCliGetPointReturns_())
						promiseArray_.push(ipCliGetPointCancellations_())
						promiseArray_.push(ipCliGetPointExpirations_())

						return Promise.all(promiseArray_)
					}).then(() => {
						// point givings
						let promiseSequence_ = Promise.resolve()

						return new Promise((resolve, reject) => {
							ipcPointGiving_.forEach(ipc => {
								let skip_ = false;

								pointGivings_.forEach(pg => {
									if(ipc['id'] == pg['old_system_point_giving_id']) { skip_ = true; }
								})

								if(!skip_) {
									const amount_ = ipc['point_given']
									const startDate_ = ipc['authorize_date']
									const endDate_ = ipc['expired_date']
									const pointCriteriumCode_ = ipc['point_criteria_id']
									const pointCriteriumName_ = ipc['point_criteria_name']
									const oldSystemPointGivingId_ = ipc['id']

									promiseSequence_ = promiseSequence_.then(() => {
										return self_.ipCliStorePointGivings(uid, amount_, startDate_, endDate_, pointCriteriumCode_, pointCriteriumName_, null, null, null, oldSystemPointGivingId_)
									})
								}
							})
							promiseSequence_ = promiseSequence_.then(() => { return ipCliGetPointGivings_() })
							promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
						})
					}).then(() => {
						// point redemptions
						let promiseSequence_ = Promise.resolve()

						return new Promise((resolve, reject) => {
							ipcItemOrders_.forEach(ipc => {
								let skip_ = false;

								pointRedemptions_.forEach(pr => {
									if(ipc['id'] == pr['old_system_item_order_id']) { skip_ = true; }
								})

								if(!skip_) {
									const point_ = ipc['point'] || 0;
									const shippingPoint_ = ipc['shipping_point'] || 0;
									const insurancePoint_ = ipc['insurance_point'] || 0;

									const amount_ = point_ + shippingPoint_ + insurancePoint_;
									const startDate_ = ipc['created']
									const endDate_ = '2999-12-31';
									const oldSystemItemOrderId_ = ipc['id']

									promiseSequence_ = promiseSequence_.then(() => {
										return self_.ipCliStorePointRedemptions(uid, amount_, startDate_, endDate_, 0, null, oldSystemItemOrderId_)
									})
								}
							})
							promiseSequence_ = promiseSequence_.then(() => { return ipCliGetPointRedemptions_() })
							promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
						})
					}).then(() => {
						// point returns
						let promiseSequence_ = Promise.resolve()

						return new Promise((resolve, reject) => {
							ipcItemOrders_.forEach(ipc => {
								if(ipc['cancel_status_id'] == 3 || ipc['cancel_status_id'] == 4) {
									let skip_ = false;

									pointReturns_.forEach(prt => {
										if(ipc['id'] == prt['old_system_item_order_id']) { skip_ = true; }
									})

									if(!skip_) {
										pointRedemptions_.forEach(prd => {
											if(ipc['id'] == prd['old_system_item_order_id']) {
												const amount_ = prd['amount']
												const startDate_ = today_;
												const endDate_ = oneYearFromToday_;
												const pointRedemptionId_ = prd['id']
												const oldSystemItemOrderId_ = ipc['id']

												promiseSequence_ = promiseSequence_.then(() => {
													return self_.ipCliStorePointReturns(uid, amount_, startDate_, endDate_, pointRedemptionId_, null, oldSystemItemOrderId_)
												})
											}
										})
									}
								}
							})
							promiseSequence_ = promiseSequence_.then(() => { return ipCliGetPointReturns_() })
							promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
						})
					}).then(() => {
						// point cancellations
						let promiseSequence_ = Promise.resolve()

						return new Promise((resolve, reject) => {
							ipcPointGiving_.forEach(ipc => {
								if(ipc['point_status_id'] == 4 || ipc['point_status_id'] == 5) {
									let skip_ = false;

									pointCancellations_.forEach(pc => {
										if(ipc['id'] == pc['old_system_point_giving_id']) { skip_ = true; }
									})

									if(!skip_) {
										pointGivings_.forEach(pg => {
											if(ipc['id'] == pg['old_system_point_giving_id']) {
												const amount_ = pg['amount']
												const startDate_ = pg['start_date']
												const endDate_ = '2999-12-31';
												const pointGivingId_ = pg['id']
												const oldSystemPointGivingId_ = ipc['id']

												promiseSequence_ = promiseSequence_.then(() => {
													return self_.ipCliStorePointCancellations(uid, amount_, startDate_, endDate_, pointGivingId_, null, oldSystemPointGivingId_)
												})

												if(pg['end_date'] >= today_) {
													promiseSequence_ = promiseSequence_.then(() => {
														return self_.ipCliUpdatePointGivings(pg['id'], { endDate: yesterday_ })
													})
												}
											}
										})
									}
								}
							})
							promiseSequence_ = promiseSequence_.then(() => resolve()).catch(error => reject(error))
						})
					}).then(() => {
/* debug */				self_.logDebug('Point Executer', 'Point sync finished...', { uid: uid })

						resolve()
					}).catch(error => {
/* error */				self_.logError('Point Executer', 'Point sync error...', { error: error })

						reject(error)
					})
				})
			}
		}
	}
</script>